// components/Loading.jsx
import "../../css/loading.scss";

export default function Loading1() {
  return (
    <div className="loading-overlay1">
      <div className="heart-loader1">
        <div className="heart-glow1"></div>
        <div className="heart-core1"></div>
      </div>
      <p className="loading-text1">Processing your donation…</p>
    </div>
  );
}
